import { useCallback, useEffect, useState } from 'react';
import { useShogunchop } from './useShogunchop';

export interface WorkspaceIndexerConfig {
  workspaceId: string;
  workspacePath: string;
  assignmentEpoch: number;
}

export function useWorkspaceIndexer(config: WorkspaceIndexerConfig | null) {
  const { desktop, resource } = useShogunchop();
  const available = desktop.state !== 'offline';
  const [isStarting, setIsStarting] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const workspaceId = config?.workspaceId;
  const workspacePath = config?.workspacePath;
  const assignmentEpoch = config?.assignmentEpoch;

  const start = useCallback(async () => {
    if (
      !available ||
      !resource ||
      !workspaceId ||
      workspacePath === undefined ||
      assignmentEpoch === undefined
    ) {
      return;
    }
    setIsStarting(true);
    setError(null);
    try {
      await resource.indexStart({
        workspace_id: workspaceId,
        workspace_path: workspacePath,
        assignment_epoch: assignmentEpoch,
      });
    } catch (cause) {
      setError(cause instanceof Error ? cause : new Error(String(cause)));
    } finally {
      setIsStarting(false);
    }
  }, [assignmentEpoch, available, resource, workspaceId, workspacePath]);

  useEffect(() => {
    void start();
  }, [start]);

  return { reindex: start, isStarting, error };
}
